const getDefaultSearchParamsState = () => {
    return {
        filter_search_text: '',
        filter_sort: [{
            column: 'name',
            sort: 'asc',
            icon: ['fas', 'angle-up']
        }],
        filter_page: 1,
        filter_limit: 10,
        loading: false
    }
}

const getDefaultFormState = () => {
    return {
        id: '',
        picture_profile_url: '',
        pictureProfile: '',
        name: '',
        email: '',
        role_id: '',
        password: '',
        password_confirmation: ''
    }
}

const getDefaultState = () => {
    return {
        list: null,
        search_params: getDefaultSearchParamsState(),
        form: getDefaultFormState()
    }
}


import {
    ADD_IN_LIST,
    REMOVE_IN_LIST,
    RESET_FORM,
    RESET_SEARCH_PARAMS,
    RESET_STATE,
    SET_FORM,
    SET_LIST,
    UPDATE_IN_LIST,
} from "./../constant-types";

import {
    updateField,
    getField
} from "vuex-map-fields";
import {
    getSearch,
    requestCreate,
    requestUpdate,
    requestDelete
} from "../api"

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [SET_LIST](state, payload) {
            // app.$set(state, 'list', payload)
            state.list = payload
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, payload) 
        },
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState();
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [UPDATE_IN_LIST](state, user) {
            let idx = _.findIndex(state.list.data, { id : user.id })
            state.list.data[idx] = user;
        },
        [REMOVE_IN_LIST](state, user) {
            let idx = _.findIndex(state.list.data, { id : user.id })
            state.list.data.splice(idx,1)
        },
        [ADD_IN_LIST](state, newUser) {
            state.list.data.unshift(newUser)
        },
        updateField

    },
    // can async
    actions: {
        loadList({
            commit,
            state,
            getters
        }, payload = {
            resetPage: false
        }) {
            if (payload.resetPage) {
                commit('updateField', {
                    path: 'search_params.filter_page',
                    value: 1
                })
            }
            // commit(UPDATE_SEARCH_PARAMS, {path: 'loading', value: true})
            return getSearch({
                    words: getters['filterSearchTextSplitted'],
                    fields: ['id', 'email', 'name', 'role>name']
                },
                [],
                [],
                // [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ['role'],
                [],
                'user',
                (successResponse) => {
                    // commit(UPDATE_SEARCH_PARAMS, {path: 'loading', value: false})
                    commit(SET_LIST, successResponse)
                },
                () => {},
                () => {}
            )
        },
        requestCreateUser({commit, state}) {
            return requestCreate('user', state.form, commit);
        },
        requestUpdateUser({commit, state}) {
            return requestUpdate('user', state.form, commit);
        },
        requestDeleteUser({
            commit
        }, user) {
            return requestDelete('user/' + user.id, {}, commit, user.name)
        }
    },
    // call variable with custom display
    getters: {
        getField,
        filterSearchTextSplitted(state) {
            return _.split(state.search_params.filter_search_text, ' ')
        }
    }
})
